module.exports = __webpack_public_path__ + "img/spherical.7c81959f.png";